/**
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *           _____                    _____                    _____
 *          /\    \                  /\    \                  /\    \
 *         /::\    \                /::\    \                /::\    \
 *        /::::\    \              /::::\    \               \:::\    \
 *       /::::::\    \            /::::::\    \               \:::\    \
 *      /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *     /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *    /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *   /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *  /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 * /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 * \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *  \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *   \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *    \:::\   \::::/    /              \::::/    /      \::::/____/
 *     \:::\  /:::/    /               /:::/    /        \:::\    \
 *      \:::\/:::/    /               /:::/    /          \:::\    \
 *       \::::::/    /               /:::/    /            \:::\    \
 *        \::::/    /               /:::/    /              \:::\____\
 *         \::/____/                \::/    /                \::/    /
 *          ~~                       \/____/                  \/____/
 */

function pad(num, size) {
  var s = num + "";
  while (s.length < size) s = "0" + s;
  return s;
}

export function urgentLevel(milli) {
  let minutes = Math.floor(milli / (1000 * 60));

  return parseInt(minutes / 10);
}

export function millisecondsToTime(milli) {
  let milliseconds = (milli % 1000) / 100;
  let seconds = Math.floor((milli / 1000) % 60);
  let minutes = Math.floor(milli / (1000 * 60));
  // let minutes = Math.floor((milli / (1000 * 60)) % 60);
  // let hours = Math.floor((milli / (1000 * 60 * 60)) % 24);

  return pad(minutes, 2) + ":" + pad(seconds, 2);
}



// WEBPACK FOOTER //
// ./src/utils/DateTimeManager.js